import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { EdmundsCpaNoAdhesionDecorator } from 'client/site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';

import { getShop5067SrpTopRecipe, isShop5067SrpTopEnabled } from './shop-5067-srp-top-utils';

const Shop5067SrpTopDecoratorUI = ({ className, shop5067Recipe, ...props }) => (
  <EdmundsCpaNoAdhesionDecorator
    {...props}
    className={classNames(className, {
      'shop-5067-srp-top': isShop5067SrpTopEnabled(shop5067Recipe),
    })}
  />
);

Shop5067SrpTopDecoratorUI.preload = (store, props) => EdmundsCpaNoAdhesionDecorator.preload(store, props);

Shop5067SrpTopDecoratorUI.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  shop5067Recipe: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  shop5067Recipe: getShop5067SrpTopRecipe(state),
});

export const Shop5067SrpTopDecorator = connect(mapStateToProps)(Shop5067SrpTopDecoratorUI);
